/**
 * MRP Runs (/mrp/runs) — run + output page.
 *
 * Runs table + Calculate button (weekly engine POST
 * /api/mrp/runs/calculate-weekly is the default; monthly variant still
 * reachable via a secondary action) + run-detail dialog (RM
 * Requirements / Weekly Breakdown sub-tabs) + Excel download + approve.
 */
import MRPDashboard from '@/pages/MRPDashboard';

export default function MRPRuns() {
  return <MRPDashboard view="runs" />;
}
